import { ProfileView } from "@authory-packages/core";
import styled, { css } from "styled-components";
import { SharedOutlineProps, SharedOutlineStyles } from "../ReusableStyledComponents/outline";
import { ResponsiveViewProps, responsiveView } from "../V3ProfileListItem/V3ProfileListItem.styles";

export const V3ProfileListWrapper = styled.div<ResponsiveViewProps>`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    margin: 0 auto;

    > div {
        ${({ $viewType, $breakpoint }) => responsiveView($viewType, $breakpoint, (view) => css`
            width: ${view === ProfileView.TwoColumnThumbnail ? "calc(50% - 48px);" : "100%"};
        `)}
        margin-bottom: 80px;
    }
`;

export const V3ProfileListContainer = styled.div`
    margin: 0 auto;
`;

export const MasonryTrailingItemPad = styled.div`
    padding: 12px;
`;

export const AddContentInViewTrigger = styled.div`
    height: 1px;
`;

export const V3ProfileEditModeWrapper = styled.div<SharedOutlineProps>`
    cursor: pointer;
    border-radius: 10px;
    padding: 10px;

    ${SharedOutlineStyles}

    > * {
        pointer-events: none;
    }
`;
